import yup from '../../../config/yup';

export const deleteValidationSchema = yup.object().shape({
  '@id': yup.string().default(''),
  '@data-type': yup.string().default('command'),
  type: yup.string().default('delete'),
  action: yup.string().default('DELETE').required('Action is required'),
  command: yup
    .string()
    .default('DELETE')
    .required('Command is required')
    .matches(/^DELETE\s+\S+/i, "Command must start with 'DELETE' followed by at least one word"),
});
